import * as React from "react";
import { DashboardComponent } from "./pages/dasboard";
import ReactNotifications from 'react-notifications-component';
import "./styles/styles.scss";
export const App = () => {
  return (
    <> 
      <ReactNotifications />
      <DashboardComponent />   
     </>
  );
};
